import axios from 'axios';
import { variables } from "../Variables";

export const getEstateStatusListFromDBservice = async (allEstates) => {

    try {
        const url = `${variables.API_URL}LocalEvents/GetBulkEstateStatus`;

        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        const getAllEstateIds = allEstates.map(estate => estate.id);

        const body = {
            clientId: allEstates[0].clientId,
            estateIds: getAllEstateIds
        }

        const response = await axios.post(url, body, config);
        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.error(error);
        return error;
    }
}

export const getEstatePurposeConfigJobStatusService = async (estateId) => {
    try {
        let url = `${variables.API_URL}LocalEvents/GetEstatePurposeConfigIdentification?estateId=${estateId}`;

        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const response = await axios.get(url, jsonconfig);

        if (response.data != undefined) {
            //console.log(response.data[0]);
            return response.data[0];
        }
    } catch (error) {
        console.log(error);
    }
}

export const dumpWhiseEventsOnEstateActivationService = async (object, userTokenValue) => {
    try {
        let savedCalendarActions = [] // [...new Set([...freeSlotIds, ...tobeConfirmedIds, ...confirmedIds])];
        let url = variables.API_URL + `calendar/FetchAndDumpEventsOnEstateActivation`;

        const config = {
            headers: {
                'Authorization': `Bearer ${userTokenValue}`,
                'Content-Type': 'application/json'
            },
        };

        const body = {
            ClientId: object.clientId,
            ActionIds: object.activeEstateList,
            EstateId: object.estateId
        };
        //console.log(body);
        const response = await axios.post(url, body, config);

        if (response.data === "Success") {
            return true;

        } else {
            return false;
        }
    } catch (error) {
        console.error("Error dumping WHISE events:", error);
        return false;
    }
}

export const updateEstateStatusInDBService = async (estateId, clientId) => {
    try {
        let url = `${variables.API_URL}LocalEvents/UpdateEstateStatus`;
        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        const body = {
            estateId: estateId,
            clientId: +clientId
        }

        const response = await axios.post(url, body, config);
        return response.data;
    
    } catch (error) {
        console.log("event update in db:", error);
    }
}


